import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatNumber } from '@progress/kendo-intl';
import cn from 'clsx';
import styles from './style.module.scss';
import { ScoreDirection } from '@components-clean/central-monitoring/panels/panel-constants';

interface RagProps {
    color: string;
    changeDirection: string;
    previousValue: number;
    currentValue: number;
    numberFormat: string;
    label: string;
}

export const getHighlightClass = (color: string) => {
    switch (color) {
        case 'Red':
            return styles.highlightedRed;
        case 'Green':
            return styles.highlightedGreen;
        case 'Amber':
            return styles.highlightedAmber;
        case 'Purple':
            return styles.highlightedPurple;
        default:
            return '';
    }
};

export const getScoreDirectionEnum = (changeDirection: string) => {
    switch (changeDirection) {
        case '0':
            return ScoreDirection.Upper;
        case '1':
            return ScoreDirection.Lower;
        case '2':
            return ScoreDirection.Matching;
        default:
            return ScoreDirection.Matching;
    }
};

const RagComponent = ({ changeDirection, previousValue, currentValue, numberFormat, label, color }: RagProps) => {
    const directionIcon = getScoreDirectionEnum(changeDirection);

    return (
        <div className="k-display-inline-flex k-flex-column">
            <span className="k-mb-1 k-text-sm">{label}</span>
            <div
                className={cn(
                    {
                        [getHighlightClass(color)]: true,
                    },
                    styles.ragComponent,
                )}
            >
                <div className="k-display-inline-flex k-flex-row k-align-items-center k-justify-content-center">
                    <div>{formatNumber(previousValue, numberFormat)}</div>
                    {(isNaN(previousValue) && isNaN(currentValue)) ||
                    (previousValue === null &&
                        currentValue === null &&
                        getHighlightClass(color) === styles.highlightedPurple) ? (
                        'N/A'
                    ) : directionIcon !== null && directionIcon !== ScoreDirection.Matching ? (
                        <FontAwesomeIcon
                            icon={['fass', 'triangle']}
                            className={cn(
                                {
                                    [styles.sortAscIcon]: directionIcon === ScoreDirection.Upper,
                                    [`${styles.sortDescIcon} k-rotate-180`]: directionIcon === ScoreDirection.Lower,
                                },
                                styles.ragIconSize,
                                'k-pl-1 k-pr-1',
                            )}
                        />
                    ) : (
                        previousValue &&
                        currentValue && (
                            <FontAwesomeIcon
                                icon={['far', 'hyphen']}
                                className={cn(styles.sortAscIcon, 'k-pl-1 k-pr-1')}
                            />
                        )
                    )}
                    <div>{formatNumber(currentValue, numberFormat)}</div>
                </div>
            </div>
        </div>
    );
};

export default RagComponent;
